import type { TRuleWithTheme } from 'styles/theme';

export const container: TRuleWithTheme = () => ({
    marginBottom: '1.94rem',
    '& .anticon': {
        alignSelf: 'self-start',
        marginTop: '0.2rem',
    },
});
